export default __webpack_public_path__ + "static/media/icon-drag-detail.85a0c0eb.svg";